// @flow

import React, { type ElementProps } from "react";
import { ErrorListProps } from "react-jsonschema-form";
import { ListGroup, ListGroupItem } from "reactstrap";
import WarningBox from "../../warning-box";

type Props = ElementProps<typeof ErrorListProps>;

const ErrorTemplate = (props: Props) => (
  <WarningBox type="warning">
    <ListGroup className="border-0">
      {props.errors.map((error, i) => (
        <ListGroupItem key={i} className="border-0">
          {error.stack}
        </ListGroupItem>
      ))}
    </ListGroup>
  </WarningBox>
);

export default ErrorTemplate;
